import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomUrlSchemeHandler } from '../../handler/CustomUrlSchemeHandler';
import { ApiService, CoreUiPartialState, DialogService, getCommunicationGroupList } from '@pos-app/core-ui';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { fileURLToPath } from 'url';

@Component({
  selector: 'app-lib-user-email-new-bulletin-form',
  templateUrl: './user-email-new-bulletin.component.html',
  styleUrls: ['./user-email-new-bulletin.component.scss'],
})
export class UserEmailNewBulletinComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isAddingNewEmailBulletin: boolean;
  @Input() isEditingEmailBulletin: boolean;
  @Output() closeAddingEmailBulletin = new EventEmitter<boolean>();

  emailBullitenForm: FormGroup;

  communicationGroupList$: any;
  communicationGroupList: any;
  private unSubscribe$ = new Subject<void>();
  selectedFile: File | null = null;
  fileName: string | null = null;

  constructor(
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private customUrlSchemeHandler: CustomUrlSchemeHandler,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private apiService: ApiService,
    private store: Store<CoreUiPartialState>
  ) {}

  ngOnInit(): void {
    this.communicationGroupList$ = this.store
      .select(getCommunicationGroupList)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res) => {
        if (res) {
          this.communicationGroupList = res;
        }
      });

    this.emailBullitenForm = new FormGroup({
      communicationGroup: new FormControl('', [Validators.required]),
      fileName: new FormControl('', [Validators.required]),
    });
    this.emailBullitenForm.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unSubscribe$)).subscribe((val) => {
      if (val.communicationGroup && val.fileName) {
        this.emailBullitenForm.setErrors(null);
      } else {
        this.emailBullitenForm.setErrors({ required: true });
      }
    });
  }

  initializeData() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isAddingNewEmailBulletin) {
      this.isAddingNewEmailBulletin = changes.isAddingNewEmailBulletin.currentValue;
    }
  }

  createProductBulletin() {}
  onSubmit() {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileName = input.files[0].name;
      this.selectedFile = input.files[0];
      //check fileName extension and if its not eml then show error
      this.emailBullitenForm.patchValue({ fileName: this.fileName });
      if (this.fileName.split('.').pop() !== 'eml') {
        this.toastr.error('Please select a valid file format type .eml');
        return;
      } else {
        this.emailBullitenForm.patchValue({ fileName: this.fileName });
      }
    }
  }
  onUpload() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      formData.append('communicationGroup', this.emailBullitenForm.value.communicationGroup);
      this.apiService.uploadPIBEmail(formData).subscribe((res) => {
        if (res) {
          this.toastr.success('File uploaded successfully');
          this.closeAddingEmailBulletin.emit(true);
        }
      });
    }
  }
  cancel() {
    this.closeAddingEmailBulletin.emit(false);
  }

  ngOnDestroy(): void {}
}
